import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "@/data/content";
import { WhatsAppButton, InstagramButton } from "./CTAButtons";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <div className={`transition-colors duration-500 ${scrolled ? "glass" : "bg-transparent"}`}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
          <a href="#top" data-testid="brand-logo" className="flex items-center">
            <img
              src="/portfolio/logo-white.png"
              alt="Capture By Parth Dixit"
              className="h-9 md:h-11 w-auto object-contain"
            />
          </a>

          <div className="flex items-center gap-3">
            <div className="hidden sm:block">
              <InstagramButton size="sm" label="Instagram" testId="nav-instagram-button" />
            </div>
            <WhatsAppButton size="sm" label="WhatsApp" testId="nav-whatsapp-button" />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
